/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "वापस जाएँ",
      "<h3 class=”header-3”>ऐक्सेसबिलिटी स्टेटस</h3> <p>यूरोपियन एक्सेसिबिलिटी एक्ट के लिए ज़रूरी है कि हम अपनी ईकॉमर्स सर्विस (पहचान और पेमेंट के तरीकों सहित) को एक्सेसिबिलिटी को ध्यान में रखकर डिज़ाइन करें, ताकि वे आसानी से समझ में आने वाली, काम करने लायक और मज़बूत हों। इसके अलावा, हमारा मकसद अपनी वेबसाइट और मोबाइल एप्लिकेशन को <a href=\"https://www.w3.org/WAI/standards-guidelines/wcag/\" target=\"_blank\">W3C के वेब कंटेंट एक्सेसिबिलिटी गाइडलाइंस 2.1, लेवल AA</a> के हिसाब से डिज़ाइन करना है। इन लक्ष्यों को पाने के लिए, हमने: </p> <ul> <li>Level Access जैसी एक्सेसिबिलिटी कंसल्टेंसी के साथ पार्टनरशिप की ताकि यह समझा जा सके कि हम अपनी सर्विसेज़ को और ज़्यादा एक्सेसिबल कैसे बना सकते हैं।</li> <li>ग्लोबल एक्सेसिबिलिटी स्टैंडर्ड्स के हिसाब से अपने डिजिटल अनुभव का मूल्याँकन किया।</li> <li>एक्सेसिबिलिटी एक्सपर्ट्स की अलग-अलग तरह की टीम से सीखा, जिसमें दिव्यांग यूज़र्स और अतिरिक्त एक्सेसिबिलिटी ज़रूरतें भी शामिल हैं।</li> </ul>",
      "<h3 class=”header-3”>फीडबैक और संपर्क</h3> <p>हालांकि हमारा मकसद सभी यूज़र्स के लिए एक्सेस पक्का करना है, फिर भी कुछ सीमाएं हो सकती हैं। हमें बेहतर बनाने में मदद के लिए फ़ीडबैक का स्वागत है, इसलिए अगर आपको एक्सेस में कोई रुकावट आती है या किसी दूसरे फ़ॉर्मेट में जानकारी चाहिए, तो कृपया हमसे accessibility@bumble.com पर संपर्क करें।</p>",
      "<h3 class=”header-3”>भविष्य में सुधार</h3> <p>हमारा एक्सेसिबिलिटी का काम जारी है। हम ये काम करते रहेंगे:</p> <ul> <li>सभी डिजिटल प्लेटफॉर्म पर एक्सेसिबिलिटी की निगरानी और समीक्षा करना।</li> <li>एक्सेसिबिलिटी को ध्यान में रखकर डिजाइन करके जानी-पहचानी दिक्कतों को ठीक करना और भविष्य में आने वाली रुकावटों को रोकना।</li> <li>इनक्लूसिव डिजाइन प्रैक्टिस को बेहतर बनाने के लिए अंदरूनी ट्रेनिंग और जागरूकता को बढ़ाना।</li> </ul>",
      "<h3 class=”header-3”>पिछली बार संपादन किया: नवंबर 2025</h3>",
      "<h3 class=”header-3”>उठाए गए कदम</h3> <p>हमारी सर्विसेज़ पर एक्सेसिबिलिटी पाने के लिए, हमने:</p> <ul> <li>पूरी एक्सेसिबिलिटी इवैल्यूएशन और गाइडेंस करने के लिए Level Access के साथ पार्टनरशिप की है।</li> <li>हमारे प्लेटफॉर्म में एक्सेसिबिलिटी टूल्स जोड़े, जिसमें कीबोर्ड के विकल्प, स्पीच इनेबलमेंट और टच-फ्री नेविगेशन जैसी सहायक टेक्नोलॉजी शामिल हैं।</li> <li>असली फीडबैक लेने और सुधारों के बारे में जानकारी देने के लिए दिव्यांग लोगों के साथ यूज़र टेस्टिंग की।</li> <li>हमारे प्रोडक्ट डेवलपमेंट लाइफसाइकल और क्वालिटी एश्योरेंस प्रोसेस में एक्सेसिबिलिटी से जुड़ी बातों को शामिल किया।</li> <li>पूरी ऑर्गनाइज़ेशन में डिजिटल एक्सेसिबिलिटी प्रोग्राम शुरू किया।</li> <li> <a href=\"https://www.levelaccess.com/bumble/\" target=\"_blank\">एक असिस्टिव कस्टमर एक्सपीरियंस प्लेटफॉर्म</a> लागू किया। यह फ्री है और उन लोगों के लिए उपलब्ध है जिन्हें टाइप करने, इशारा करने, माउस हिलाने या पढ़ने में परेशानी होती है। इसमें माउस और कीबोर्ड रिप्लेसमेंट, वॉइस रिकग्निशन, स्पीच इनेबलमेंट, हैंड्स-फ्री/टच-फ्री नेविगेशन, और भी बहुत कुछ जैसे टूल्स शामिल हैं।</li> </ul>",
      "<h3 class=”header-3”>हमारी पॉलिसी</h3> <p>Bumble पर, समानता हमारे मूल्यों का केंद्र है। यह हमारे लिए सिर्फ एक लोकप्रिय शब्द से कहीं बढ़कर है—हम Bumble के अनुभवों को सभी के लिए सुलभ, निष्पक्ष और समान बनाने के लिए कोशिश करते हैं।</p> <p>यह एक्सेसिबिलिटी स्टेटमेंट हमारे यूज़र्स को हमारी सेवा की एक्सेसिबिलिटी के बारे में बताने के लिए तैयार किया गया है, जिसमें ज़रूरी कानूनी और तकनीकी मानकों का अनुपालन भी शामिल है। यह एक्सेसिबिलिटी स्टेटमेंट हमारी सर्विस [RS2] के उन हिस्सों पर लागू होती है जो यूरोपियन एक्सेसिबिलिटी एक्ट के तहत आते हैं, खासकर हमारी ईकॉमर्स सर्विस, जो यूज़र्स को कई बेहतर, प्रीमियम Bumble फीचर्स में अपग्रेड करने की सुविधा देती हैं। इन सर्विस को Bumble ऐप के ज़रिए एक्सेस किया जा सकता है।</p>",
      "EAA ऐक्सेसबिलिटी स्टेटमेंट",
      "App Store से डाउनलोड करें",
      "Google Play से प्राप्त करें",
      "कैरोसेल",
      "स्लाइड {{number}}",
      "अगली स्लाइड",
      "पिछली स्लाइड",
      "स्लाइड",
      "स्लाइड {{total}} में से {{number}}",
      "मेरी व्यक्तिगत जानकारी को न बेचें और न ही साझा करें",
      "मेरी निजी जानकारी न बेचें या न शेयर करें",
      "Bumble पर तारीफ भेजें ताकि आप दिखा सकें कि आपको उनकी प्रोफ़ाइल पसंद है, और मैच से पहले उनका ध्यान अपनी ओर आकर्षित करें। अभी आज़माएँ",
      "तारीफें | तारीफ कैसे भेजें | Bumble",
      "एक व्यक्तिगत पेज जो आपके लिए सबसे अनुकूल लोगों को हाइलाइट करता है, हर रोज़ रिफ्रेश किया जाता है",
      "खोजें | अनुकूल लोगों को खोजें | Bumble",
      "अपनी गति से डेट करें और गुप्त मोड के साथ अपने Bumble प्रोफ़ाइल को कौन देखता है, इस पर नियंत्रण रखें। हमारी गाइड में Bumble पर गुप्त मोड का उपयोग करने के बारे में अधिक जानें",
      "गुप्त मोड | अपनी प्रोफ़ाइल छिपाएं | Bumble",
      "Bumble के असल जीवन के इवेंट में मिलने के बाद, ऐप में बातचीत जारी रखकर केमिस्ट्री बनाएं।",
      "तुरंत मैच | बातचीत को ऐप पर जारी रखें |\nBumble",
      "क्या आपको ब्रेक या अपने लिए कुछ समय चाहिए? Bumble के स्नूज़ मोड से अपने Bumble अकाउंट को रोकने का तरीका जानें। यह आपको अपनी शर्तों पर डेट करने की सुविधा देता है",
      "स्नूज़ मोड | अपना खाता रोकें | Bumble",
      "क्या आपने अभी-अभी Bumble पर किसी ऐसे व्यक्ति को देखा है जिसे आप वाकई पसंद करते हैं? उन्हें यह दिखाने के लिए SuperSwipe का उपयोग करें कि आप गंभीर हैं। आरंभ करने के लिए उनकी प्रोफ़ाइल पर स्टार पर टैप करें, या यहाँ अधिक विवरण देखें",
      "Bumble SuperSwipe | SuperSwipe क्या है? | Bumble",
      "काम या मौज-मस्ती के लिए यात्रा कर रहे हैं? Bumble पर ट्रेवल मोड आपको किसी नई जगह पर मज़ेदार नए कनेक्शन बनाने और जहाँ भी आप जाएँ, डेट करने में मदद कर सकता है। ट्रेवल मोड के बारे में अभी यहाँ जानें",
      "Bumble का ट्रेवल मोड | जहां भी जाएं डेट करें | Bumble",
      "जानना है कि क्या मैसेजस में महसूस होने वाला जुड़ाव असल ज़िंदगी में भी महसूस होगा? अभी Bumble पर वीडियो चैट या वॉयस कॉल आज़माएँ और वाइब चेक करें",
      "वीडियो चैट | एक कॉल करें | Bumble",
      "Bumble डेट",
      "हमारे ऐप्स",
      "हमारे बारे में",
      "करियर",
      "हमसे संपर्क करें",
      "निवेशक",
      "शॉप",
      "कंपनी",
      "ऐप को डाउनलोड करें",
      "Bumble पर ऐक्सेसबिलिटी",
      "दिशानिर्देश",
      "कुकीज़ प्रबंधित करें",
      "मॉडर्न स्लेवरी एक्ट",
      "संग्रह पर सूचना",
      "प्राइवेसी पॉलिसी",
      "नियम और शर्तें",
      "कानूनी",
      "वाशिंगटन कंज्यूमर हैल्थ प्राइवेसी पॉलिसी",
      "Bumble ऐप प्राप्त करने के लिए QR कोड स्कैन करें",
      "साइन इन करें",
      "यहाँ कान्ट्रैक्ट समाप्त करें",
      "अभी डाउनलोड करें",
      "शुरुआत करने के लिए बस अपना QR कोड स्कैन करें।",
      "अपनी अगली डेट खोजें",
      "ऐप प्राप्त करें",
      "Bumble होमपेज",
      "मेनू बंद करें",
      "मेनू खोलें",
      "जल्द आ रही हैं: Bumble प्रेम कहानियाँ",
      "अपनी भाषा चुनें",
      "भाषा चुनें",
      "फूटर",
      "Bumble पर ऐक्सेसबिलिटी\n\n---",
      "Apple और Apple का लोगो Apple Inc के ट्रेडमार्क हैं।",
      "Bumble BFF",
      "Bumble Bizz",
      "Bumble डेट",
      "करियर",
      "इवेंट्स",
      "Google Play, Google LLC का ट्रेडमार्क है.",
      "दिशानिर्देश",
      "निवेशक",
      "कुकीज़ प्रबंधित करें",
      "कुकीज़ प्रबंधित करें",
      "Modern Slavery Act स्टेटमेंट",
      "संग्रह पर सूचना",
      "गोपनीयता नीति",
      "सीजनल डेटिंग गाइड्स",
      "नियम और शर्तें",
      "ऐप",
      "वाशिंगटन कंज्यूमर हैल्थ डाटा प्राइवेसी पॉलिसी",
      "हमारे बारे में",
      "एम्बेसडर",
      "नये दोस्त बनाएं और अपनी कम्यूनिटी को खोजें",
      "पेशेवर रूप से नेटवर्क बनाएं और करियर में आगे बढ़ें",
      "कोई रिश्ता, कुछ अनौपचारिक, या बीच का कुछ भी खोजें",
      "The Buzz",
      "और जानिये",
      "ट्रेवल मोड के ग्लोबल हो जाएं",
      "Date",
      "इवेंट्स",
      "फीचर्स",
      "Compliments",
      "उन्हें कुछ Compliments दें ताकि आप भीड़ से अलग दिखें।",
      "खोज",
      "एक व्यक्तिगत पेज जो आपके लिए सबसे अनुकूल लोगों को हाइलाइट करता है, हर रोज़ रिफ्रेश किया जाता है",
      "गुप्त मोड",
      "अपने बॉस, रिश्तेदारों या पूर्व साथियों से अपनी प्रोफ़ाइल छिपाने के लिए गुप्त मोड का उपयोग करें।",
      "तुरंत मैच",
      "क्या आपने Bumble के असल जीवन के इवेंट में बातचीत शुरू की है? इसे ऐप पर जारी रखें।",
      "स्नूज़ मोड",
      "स्नूज़ मोड के साथ डेटिंग को होल्ड पर रखें। जब आप फिर से डेट करने के लिए तैयार हों, आपको पता ही है कि हम कहाँ हैं।",
      "SuperSwipe",
      "प्रोफ़ाइल वाइब जांच में पास हुई? SuperSwipe से उन्हें बताएं।",
      "ट्रैवल",
      "ट्रैवल के साथ दुनिया में कहीं भी अपना ड्यूटी-फ्री स्नैक और मैच ढूंढें।",
      "वीडियो चैट",
      "क्या आप किसी से व्यक्तिगत तौर पर मिलने के लिए तैयार है यह देखने के लिए वीडियो चैट और ऑडियो कॉल का उपयोग करें।",
      "Bumble ऐप प्राप्त करें",
      "BFF",
      "सुरक्षा",
      "कहानियाँ",
      "सहायता",
      "शॉप",
      "मुख्य",
      "उन्हें कुछ Compliments दें ताकि आप भीड़ से अलग दिखें।",
      "Compliments",
      "ऐसे फीचर जो सच्चे, सम्मानजनक और सार्थक रिश्तों के लिए जगह बनाने के उद्देश्य से तैयार किए गए हैं।",
      "अपने बॉस, रिश्तेदारों या पूर्व साथियों से अपनी प्रोफ़ाइल छिपाएं।",
      "गुप्त मोड",
      "स्नूज़ मोड के साथ डेटिंग को होल्ड पर रखें।",
      "स्नूज़ मोड",
      "कोई पसंद का व्यक्ति दिखा? उन्हें बताएं।",
      "SuperSwipe",
      "Date को एक्सप्लोर करें",
      "अपना ड्यूटी-फ्री स्नैक और मैच कहीं भी पाएं।",
      "ट्रैवल",
      "अपना घर छोड़े बिना असल ज़िंदगी में करीब पहुंचें।",
      "वीडियो कॉलस",
      "सीधे अपने ब्राउज़र पर Bumble अनुभव प्राप्त करें।",
      "वेब ऐप",
      "हमारे लीडर Bumble की मान्यताओं को देश भर के समुदायों में लाने में सहायता करते हैं।",
      "कम्यूनिटी के लीडर",
      "ऐसे फीचर जो आपको अपने जैसे लोगों को ढूँढने और अपनी पसंद की चीज़ों पर जुड़ने में मदद करते हैं।",
      "एक ग्रुप मीटअप आयोजित करें, या आस-पास की स्थानीय इवेंट्स को खोजें।",
      "Plans",
      "BFF को एक्सप्लोर करें",
      "आपको प्यार और दोस्ती पाने में मदद करने के लिए सभी आवश्यक मार्गदर्शन और प्रेरणा।",
      "मनचाही दोस्ती पाने में आपकी मदद करने के लिए सलाह और कहानियाँ।",
      "फ्रेंडशिप हब",
      "टोक्यो से टोरोन्टो टक, दुनिया भर में Bumble पर प्यार ढूंढें।",
      "प्रेम कहानियाँ",
      "परफेक्ट डेट प्लान करें—इससे कोई फर्क नहीं पड़ता कि आप कब, कहां या किसके साथ डेटिंग कर रहे हैं।",
      "सीजनल डेटिंग गाइड्स",
      "कहानियाँ एक्सप्लोर करें",
      "मुख्य सामग्री पर जाएं",
      "Bumble का लोगो",
      "नेविगेशन मेनू बंद करें",
      "नेविगेशन मेनू खोलें",
      "Bumble की संस्थापक और CEO व्हिटनी वोल्फ हर्ड की फ़ोटो",
      "व्हिटनी वोल्फ हर्ड ने Bumble को एक लक्ष्य के साथ लॉन्च किया: प्यार पाने के लिए सबसे भरोसेमंद जगह बनाना, जहाँ महिलाएँ पहला कदम बढ़ाएं और सभी संबंध सम्मान पर आधारित हों।{{__EOL__}}{{__EOL__}} सीईओ के रूप में, वह अब भी इसी विश्वास के साथ आगे बढ़ रही हैं कि ऑनलाइन प्यार पाना मर्जी के अनुसार, सुरक्षित और प्रामाणिक होना चाहिए। Bumble डेटिंग से कहीं बढ़कर है। यह लोगों को वह खोजने में मदद करने के बारे में है जो वास्तव में मायने रखता है—देखभाल, नीयत और दिल के साथ। इसका मतलब है तकनीक और AI का इस्तेमाल मानव जुड़ाव को गहरा करने के लिए करना, न कि उसे बदलने के लिए। हम वह सब इस्तेमाल कर रहे हैं जो हमने सीखा है—अच्छा, अपूर्ण और सच्चा—ताकि हमारी पूरी कम्यूनिटी Bumble पर हमेशा स्वागत योग्य महसूस करे।",
      "व्हिटनी वोल्फ हर्ड",
      "कार की पिछली सीट पर एक-दूसरे का हाथ थामे मुस्कुराते हुए चुंबन करने के लिए झुकी हुई जोड़ी, बाहर हरियाली है।",
      "हम समझते हैं कि प्यार—सभी रूपों में—खुश और स्वस्थ जीवन का आधार है।",
      "नमस्ते। हम लव कंपनी हैं।",
      "दो प्रोफ़ाइलों और बातचीत शुरू करने के लिए झलक के साथ Bumble मैच स्क्रीन।",
      "नतीजा? मेम्बर-पहले प्लेटफ़ॉर्म, जिसे प्यारे और स्वस्थ रिश्ते बनाने के लिए बनाया गया।",
      "{{date}} में, हमने डेटिंग के नियमों को दुबारा लिखा।",
      "हमारा मिशन लोगों को प्यार के करीब लाना है।",
      "हमारा मिशन",
      "हमने डेटिंग के नियमों को बदला और महिलाओं को पहले कदम बढ़ाने का मौका दिया।",
      "Bumble का जन्म हुआ",
      "{{bff}} को लोगों को अपने जैसे लोग ढूँढ़ने में मदद करने के लिए लॉन्च किया गया है। क्योंकि प्यार दोस्ती भी होता है।",
      "डेटिंग से परे",
      "सेरेना विलियम्स ने हमें सुपर बाउल में महिलाओं को आगे लाने में मदद की।",
      "सुपर बाउल की शुरुआत",
      "हमने कोविड-19 महामारी के दौरान डेटिंग को नेविगेट करने के लिए नए फ़ंक्शन लॉन्च किए।",
      "डेट्स वायरल हो गई",
      "हम पब्लिक गए—और ऐसा करने वाली वो सबसे कम उम्र की महिला है।",
      "इतिहास रचा गया",
      "हमारी एंटी-साइबरफ्लैशिंग टेक्नोलॉजी के साथ-साथ, हमने महिलाओं की सुरक्षा के लिए हमारे नीतियों को विस्तार किया।",
      "बेहतर सुरक्षा",
      "हमने महिलाओं की स्पोर्ट्स पर उतना ही ध्यान केंद्रित किया जितना होना चाहिए।",
      "WNBA x Bumble",
      "अब, हम एक ऐसा भविष्य बना रहे हैं जहाँ सभी के लिए प्यार संभव हो।",
      "प्यार से नेतृत्व करना",
      "हमने एक बोल्ड मूव से शुरुआत की। आज हम प्यार पाने के लिए सबसे भरोसेमंद और प्रभावी जगह बना रहे हैं।",
      "जानने के लिए स्क्रॉल करें",
      "बाएं स्क्रॉल करें",
      "दाएं स्क्रॉल करें",
      "हमारी कहानी",
      "हमारी उपलब्ध नौकरियाँ देखें",
      "प्यार पाने के लिए सबसे भरोसेमंद जगह बनाने में हमारी मदद करें।",
      "हमारे साथ काम करें",
      "BFF ऐप स्क्रीन जिस पर यूज़र प्रोफ़ाइल व्यू और दोस्तों से जुड़ने के लिए रुचि बैज हाइलाइट किए गए हैं",
      "चाहे आप किसी नए शहर में हों या बस अपना दायरा बढ़ाना चाहते हों, {{bff}} आपके लिए अपने जैसी सोच वाले लोगों से मिलना आसान बनाता है जो आपकी पसंद से मेल खाते हैं।",
      "अपने लोगों को खोजें",
      "Bumble प्रोफाइल का कोलाज जिसमें विभिन्न लोगों को ID वेरीफाइड बैज के साथ दिखाया गया है, जिसमें बीच में मिरर सेल्फी लेती एक महिला भी शामिल है।",
      "चाहे आप डेटिंग में नए हों या फिर से डेटिंग करने के लिए तैयार हों, Bumble Date को आपको सुरक्षित और सार्थक तरीके से प्यार के करीब लाने के लिए बनाया गया है।",
      "अपने साथी को ढूंढें",
      "एक पार्क में स्केटबोर्ड पकड़ कर मुसकुराती हुई महिला",
      "बाहर घूमना",
      "शहरी में पार्क में दौड़ते और मुस्कुराते हुए आदमी",
      "दौड़ना",
      "एक छोटे से रूएंदार कुत्ते को पकड़ कर खड़ी महिला",
      "डॉग पेरन्ट",
      "Bumble को डाउनलोड करें",
      "हम चाहते हैं कि हमारे मेम्बर ऐसे सच्चे और अच्छे रिश्ते पाएँ जो उन्हें आत्मविश्वास और खुशी दें।",
      "हम लोगों को प्रेम से जोड़ने के लिए हैं।",
      "एक काली पोनी टेल वाली महिला, काला टॉप और सिर पर चश्मे पहने मुस्कुरा रही है, उसके पीछे समुद्र है।",
      "दाढ़ी वाला आदमी जिसने धारीदार शर्ट पहनी है, हाथ में कैमरा लिए बाहर खड़ा है, बैकग्राउंड में पेड़ और इमारतें हैं।",
      "महिला ने सतरंगी पट्टी वाली लाल रंग की जैकेट और सिल्वर रंग के हैडफोन पहने हैं, हरा स्टार नेकलेस पहने हुए कैमरे की तरफ देख रही है।",
      "काले-सफ़ेद पोर्ट्रेट में मुसकुराते हुए गले लगाती हुई एक जोड़ी",
      "{{name1}} और {{name2}}, {{num}} में शादी की",
      "और जानिये",
      "और कहानियाँ पढ़ें",
      "\"{{__EOL__}}हम दोनों स्वाभाविक रूप से सकारात्मक और खुशमिजाज हैं, लेकिन जब हम एक साथ होते हैं, तो ऐसा लगता है कि ऐसा कुछ भी नहीं है जिसे हम पा नहीं सकते।",
      "एक टेनिस कोर्ट पर दो लोग हँस रहे हैं; एक ने टेनिस बॉल अपनी आँखों पर रखी हुई है",
      "व्यक्तिगत रूप से मिलें",
      "Bumble IRL (असल जीवन में) इवेंट्स का मतलब है कि आप टाइपिंग बंद करके बात करना शुरू कर सकते हैं। अकेले आएं या दोस्त को साथ में लाएं—एक नये कनेक्शन के साथ वापिस जाएं।",
      "व्यक्तिगत रूप से चैट शुरू करें",
      "लोग फ़ोटो, वीडियो चैट, और विशेषज्ञों की सलाह के ज़रिए Bumble पर नए कनेक्शन बना रहे हैं.",
      "साइन अप करें",
      "हमारे Member Circle से जुड़कर Bumble के भविष्य को आकार देने में मदद करें। मेम्बर्स की यह चुनी हुई कम्यूनिटी चैट, चर्चाओं और प्रोडक्ट टेस्ट के ज़रिए सीधे हमारी टीम के साथ अपने विचार शेयर करती है।{{__EOL__}}{{__EOL__}}भाग लेने वालों को नए फ़ीचर्स तक पहले एक्सेस, आने वाले कैंपेन की झलक, और Bumble को सभी के लिए और बेहतर बनाने का मौका मिलता है।",
      "अपने आइडिया शेयर करें",
      "उन्हें जानना चाहते हैं? Bumble पर वीडियो चैट का उपयोग करें",
      "वीडियो कॉल शुरू करने के लिए बस अपने चैट में वीडियो आइकन पर टैप करें, और वह भी कोई व्यक्तिगत संपर्क जानकारी साझा किए बिना।",
      "Bumble पर वीडियो चैट कैसे काम करती है?",
      "नहीं। Bumble पर सभी कॉल और चैट आपकी व्यक्तिगत जानकारी को सुरक्षित रखते हैं। जब तक आप उन्हें नहीं बताएंगे, उन्हें आपका नंबर या कोई अन्य संपर्क विवरण नहीं मिलेगा।",
      "क्या मेरा मैच मेरा फ़ोन नंबर देखेगा?",
      "बिल्कुल! अगर आप आमने-सामने बात करने के लिए तैयार नहीं हैं, तो वॉयस कॉल आपको ऑडियो के ज़रिए कनेक्ट करने की सुविधा देता है। इसके बजाय बस कॉल आइकन चुनें।",
      "क्या मैं ऑडियो कॉल को आज़मा सकता हूँ?",
      "हमें \"मैसेज प्राप्त हुआ* सूचना पसंद है। लेकिन हम जानते हैं कि यह बताना मुश्किल है कि आपकी चैट व्यक्तिगत रूप से उतनी अच्छी होगी या नहीं। यहीं पर वीडियो और ऑडियो कॉल काम आते हैं।",
      "Bumble पर वीडियो चैट",
      "<a href={{video_chat_url}}>वीडियो चैट और ऑडियो कॉल</a> आपको एक-दूसरे को जानने और यह तय करने में मदद कर सकते हैं कि क्या आप बात को ऐप से परे ले जाना चाहते हैं। सबसे अच्छी बात? जब आप Bumble के ज़रिए कॉल करते हैं, तो आपको फ़ोन नंबर एक्सचेंज करने की ज़रूरत नहीं होती है - इसलिए आपकी निजी जानकारी तब तक सुरक्षित रहती है जब तक आप शेयर करने के लिए तैयार नहीं होते।",
      "वीडियो चैट से अपनी केमिस्ट्री देखें",
      "ऑनलाइन और ऑफलाइन डेटिंग के बीच के अंतर को पाटें, और तय करें कि क्या अब समय आ गया है कि हम आगे बढ़ें और मिलें।",
      "उन्हें बेहतर तरीके से (और तेजी से) जानें। आमने-सामने की बातचीत या फोन पर बातचीत किसी के बारे में बहुत कुछ बता सकती है।",
      "कंट्रोल आपके हाथ में है। हम आपकी संपर्क जानकारी निजी रखेंगे, ताकि आप चुन सकें कि उन्हें कब शेयर करना है।",
      "देखें कि क्या आप व्यक्तिगत रूप से मिलने के लिए तैयार हैं",
      "त्वरित वाइब जांच आज़माएं",
      "निजी जानकारी दिए बिना कनेक्ट करें",
      "आपको वीडियो चैट और कॉल का उपयोग क्यों करना चाहिए",
      "बातचीत शुरू करने के लिए तैयार हैं? आप Bumble ऐप में अपनी चैट से ही चुन सकते हैं कि ऑडियो कॉल शुरू करना है या वीडियो कॉल। वीडियो कॉल शुरू करने के लिए, ऊपरी दाएँ कोने में ग्रे वीडियो कैमरा आइकन पर टैप करें। आपको आइकन के बगल में तीन बिंदु भी दिखाई देंगे, इस पर क्लिक करें और आपको ऑडियो कॉल करने का विकल्प भी दिखाई देगा।",
      "वीडियो चैट कैसे करें",
      "Compliments को आज़माने के लिए तैयार हैं?",
      "जब आप कोई Compliment भेजते हैं, तो उसे प्राप्त करने वाला व्यक्ति उसे तब देख सकेगा जब आप उनके 'आपके लिए' सेक्शन में दिखाई देंगे।",
      "जब आप Bumble पर किसी को Compliment भेजते हैं तो क्या होता है?",
      "अगर उनके Compliment ने आपका ध्यान खींचा है, तो आगे बढ़ें और उनके साथ मैच करें। आपको अपनी चैट में Compliment दिखाई देगा, और हमेशा की तरह <a href={{make_the_first_move_url}}>पहला कदम बढ़ाने</a> के नियम लागू होंगे।",
      "मैं किसी Compliment का जवाब कैसे दूँ?",
      "आप {{num}} [[Compliments:num]] निःशुल्क भेज सकते हैं। जब आप सब खत्म कर लें, तो आप Bumble ऐप में 30 तक के पैक में और खरीद सकते हैं। इनमें से एक का उपयोग उस Compliment को भेजने के लिए किया जाएगा (बाकी को तब के लिए बचाकर रखें जब आपको कोई और प्रोफ़ाइल पसंद आए)। चिंता न करें, वे समाप्त नहीं होंगे!",
      "मैं कितने Compliments भेज सकता हूँ?",
      "एक अच्छा शब्द (या दो) बहुत काम आ सकता है। अगर आप कोई Compliment भेजना चाहते हैं, लेकिन आपके अंगूठे कीबोर्ड पर ही अटके हुए हैं, तो प्रेरणा के लिए ये आज़माएँ:",
      "अधिक उदाहरण देखें",
      "“जो कोई भी [अरिजित] को पसंद करता है, उसकी पसंद अच्छी है।”",
      "“आपकी मुस्कान संक्रामक है!”",
      "“आपकी बायो ने मुझे हंसाया। बहुत बढ़िया।”",
      "Bumble पर बेहतर तारीफें कैसे भेजें",
      "क्या आप उनका दिन बनाना चाहते हैं? लगता है आप Compliments का इस्तेमाल करने के लिए तैयार हैं।",
      "Bumble पर Compliments",
      "Bumble पर Compliments का इस्तेमाल करके संभावित मैच को बताएं कि आपको उनकी प्रोफ़ाइल पसंद है (और शायद उन्हें शर्माने के लिए मजबूर भी कर दें)। आपको अपनी {{service_level_lexeme_name}} मेंबरशिप के हिस्से के रूप में Compliments मिलते हैं। यह मैच होने से पहले ही मैसेज भेजने और प्राप्त करने का एक तरीका भी है।",
      "Compliments फीचर कैसे काम करता है",
      "जब आपको कोई Compliment मिलता है, तो वह आपके \"आपके लिए\" भाग में भेजने वाले की प्रोफ़ाइल पर दिखाई देगी। आपको एक सूचना भी मिलेगी जिसमें बताया जाएगा कि किसी को आपकी प्रोफ़ाइल का कोई हिस्सा पसंद आया है।",
      "अपनी तारीफें देखें",
      "आप किसी व्यक्ति की प्रोफ़ाइल के नीचे पीले दिल के आइकन पर टैप करके Compliment भेज सकते हैं। आप कहाँ टैप करते हैं यह महत्वपूर्ण है, क्योंकि आप उस विशिष्ट फ़ोटो या उनकी प्रोफ़ाइल के हिस्से की तारीफ़ कर रहे होंगे! जब आप क्लिक करेंगे, तो आपके लिए अपना मैसेज लिखने के लिए एक टेक्स्ट बॉक्स खुलेगा (बस सुनिश्चित करें कि इसमें केवल 150 अक्षर हों)।",
      "तारीफ भेजें",
      "खोज को अभी आज़माने के लिए Bumble को डाउनलोड करें",
      "हर दिन सुबह 9 बजे से, आपको खोज में नए लोग दिखाई देंगे। आप उनसे उन बातों के आधार पर जुड़ सकते हैं जो आपमें एक जैसी हैं।",
      "खोज पेज कब अपडेट होता है?",
      "आपका खोज पेज संभावित मैचों को 3 मुख्य श्रेणियों में वर्गीकृत करता है: समान रुचियां, समान डेटिंग लक्ष्य और समान समुदाय। पिछले मैच के आधार पर प्रोफ़ाइल के सुझाव भी दिखाए जाते हैं।",
      "मेरा खोज पेज कैसे तैयार किया गया है?",
      "एक व्यक्तिगत पेज जो आपके सबसे अनुकूल लोगों को हाइलाइट करता है, हर रोज़ रिफ्रेश किया जाता है",
      "{{qr_code}} खोज के साथ अपनी वाइब से मेल खाने वाले लोगों को खोजें",
      "खोज आपको उन लोगों का चयन दिखाता है जो हमें लगता है कि आपको पसंद आएंगे, जो आपकी समान रुचियों, डेटिंग लक्ष्यों और समुदायों पर आधारित है।",
      "खोज को आज़माएं",
      "क्या आप आपसी सहमति बनाने के लिए कोई नया रास्ता खोज रहे हैं?",
      "खोज पेज को हर दिन अपडेट किया जाता है, ताकि आपको और भी अधिक लोग दिखें जिनके साथ आप अनुकूल हैं - ताकि आप मैच की तलाश में कम समय बिताएं, और उन लोगों के साथ अधिक समय बिता सकें जिनके साथ आपकी वाइब बैठती है।",
      "सिफ़ारिशें हर रोज़ रिफ्रेश की जाती हैं",
      "खोज की सिफारिशें आपकी प्रोफ़ाइल और आपके साथ पहले से मैच हुए लोगों पर आधारित होती हैं, इसलिए आपको ऐसे लोग दिखाई देंगे जिन्हें आपकी पसंद की चीज़ें पसंद हैं और जिन्हें वो चाहिए जो आप चाहते हैं - चाहे वह शाकाहारी पनीर रोल हो या लंबी समय तक चलने वाले संबंध।",
      "आपके अनुसार{{__EOL__}}निजीकृत",
      "Bumble को डाउनलोड करें",
      "अक्सर पूछे जाने वाले सवाल",
      "गोपनीय रूप से Bumble को ब्राउज़ करने के लिए तैयार हैं?",
      "जब आप गुप्त मोड सक्रिय करते हैं, तो आप अन्य Bumble सदस्यों को तब तक दिखाई नहीं देंगे, जब तक कि आपको उनकी प्रोफ़ाइल पसंद न आए।",
      "गुप्त मोड कैसे काम करता है?",
      "गुप्त मोड के बिना, आपकी प्रोफ़ाइल Bumble पर अन्य डेटर्स को दिखाई देती है, जब आप उनकी पसंद, जैसे कि उम्र और स्थान के अनुसार होते हैं। जब आप गुप्त मोड सक्रिय करते हैं, तो लोग आपको तभी देख पाएँगे जब आप उन्हें पसंद करेंगे।",
      "मुझे Bumble के गुप्त मोड पर कौन देख सकता है?",
      "गुप्त मोड का उपयोग करना <a href={{blocking_on_bumble_url}}>Bumble पर किसी को ब्लॉक करने</a> जैसा नहीं है। इस सुविधा के साथ, यदि आप किसी को पसंद करते हैं (या यदि आपने उन्हें पहले मैसेज किया है), तो वे आपकी प्रोफ़ाइल देख पाएंगे।",
      "क्या गुप्त मोड किसी को ब्लॉक करने जैसा है?",
      "Bumble के गुप्त मोड से कंट्रोल करें कि आपकी प्रोफ़ाइल कौन देख सकता है।",
      "Bumble पर गुप्त मोड",
      "अगर आप डेटिंग से एक कदम पीछे हटना चाहते हैं, या Bumble को ब्राउज़ करना चाहते हैं पर यह नहीं चाहते कि अन्य डेटर्स आपकी प्रोफ़ाइल को देखें, तो आप गुप्त मोड पर स्विच कर सकते हैं। इस सुविधा को चालू करने का मतलब है कि हम आपको सभी से छिपा देंगे - जब तक कि आप उन्हें पहले पसंद न करें। यह आपको यह नियंत्रित करने की अनुमति देता है कि आप क्या शेयर करते हैं, और आपको कौन देखता है।",
      "गुप्त मोड के साथ अपने प्रोफ़ाइल छिपाएं",
      "आप तय करते हैं कि आपकी फ़ोटोज़ और व्यक्तिगत जानकारी कौन देख सकता है।",
      "क्या आप अपनी प्रोफ़ाइल में कुछ निजी जानकारी शामिल करना चाहते हैं? आप अपनी मौजूदा प्रोफ़ाइल के साथ अपनी मनचाही जानकारी साझा कर सकते हैं।",
      "किसी पूर्व साथी, अपने सहकर्मी या किसी अन्य व्यक्ति से, जो आपके डेटिंग राडार पर नहीं है, मिलने की चिंता किए बिना, स्वतंत्र रूप से ब्राउज करें।",
      "पूरा कंट्रोल हाथ में लें",
      "चुनें कि आप क्या शेयर करते हैं",
      "असहज आमने-सामने से बचें",
      "आपको गुप्त मोड क्यों पसंद आएगा",
      "गुप्त मोड {{service_level_lexeme_name}} और {{service_level_lexeme_name_two}} के मेंबर्स के लिए उपलब्ध है। साइन अप करने के बाद, आप अपने प्रोफ़ाइल टैब पर जाकर, ऊपरी दाएँ कोने में सेटिंग पर टैप करके और गुप्त मोड पर स्विच करके इसे चालू कर सकते हैं।",
      "{{service_level_lexeme_name}} पर अपग्रेड करें",
      "Bumble पर गुप्त मोड का उपयोग कैसे करें",
      "तुरंत मैच को आज ही आज़माने के लिए Bumble को डाउनलोड करें",
      "Bumble ऐप में, अपनी स्क्रीन के नीचे प्रोफ़ाइल आइकन पर जाएँ। वहाँ से, आपको स्क्रीन के ऊपर दाईं ओर QR कोड आइकन मिलेगा। इसे एक्सेस करने के लिए उस पर टैप करें।",
      "मैं अपना पर्सनल QR कोड कहाँ पा सकता/सकती हूँ?",
      "नहीं! आपको मोबाइल डेटा या Wi-Fi के जरिए इंटरनेट से कनेक्ट होना होगा, और तुरंत मैच के काम करने के लिए वर्तमान, लाइव QR कोड का उपयोग करना होगा।",
      "क्या मैं साझा करने के लिए अपने QR कोड का स्क्रीनशॉट ले सकता हूँ?",
      "नहीं! अगर कोई व्यक्ति कोड स्कैन करता है, तो आपका मैच अपने आप हो जाएगा।",
      "क्या दोनों लोगों को QR कोड स्कैन करने की जरूरत है?",
      "तुरंत मैच के साथ, आप स्वचालित रूप से देख सकते हैं कि आप में और आपके नए मैच में क्या समानता है - जिससे आपको शुरुआत से ही अपनी अनुकूलता की झलक मिल जाती है।",
      "सामान्य आधार खोजें, तेजी से",
      "क्या आपने Bumble के असल जीवन के इवेंट में बातचीत शुरू की है? इसे ऐप पर जारी रखें।",
      "अपने मीट-क्यूट को {{qr_code}} तुरंत मैच में बदलें",
      "तुरंत मैच आपके प्यारे साथी को “चलो बात करते रहें” के स्तर तक ले जाना आसान बनाता है, बिना नंबर या सोशल प्रोफाइल बताये या जाने। बस उन्हें Bumble पर मैच करने के लिए अपना QR कोड स्कैन करने दें।",
      "तुरंत मैच को आज़माएं",
      "क्या Bumble के असल जीवन के ईवेंट में किसी से मुलाकात हुई?",
      "सोशल प्रोफाइल या फ़ोन नंबर लेने-देने के बजाय, तुरंत मैच आपको पहले ऐप में माहौल समझने देता है। इस तरह, आप Bumble के सुरक्षा सुविधाओं की बदौलत अपनी शर्तों पर एक-दूसरे को बेहतर तरीके से जान सकते हैं।",
      "कनेक्ट करने का सुरक्षित तरीका",
      "Bumble के असल जीवन के इवेंट में मिलने के बाद, ऐप में बातचीत जारी रखते हुए और साझा रुचियों पर जुड़कर केमिस्ट्री बनाएं - चाहे वह परफेक्ट चाय के लिए प्यार हो या बॉलीवुड के लिए।",
      "बातचीत जारी रखें",
      "एक ब्रेक लेना चाहते हैं? स्नूज़ मोड को आज़माएं",
      "हां, आप अपनी सेटिंग या कतार में जाकर जब चाहें स्नूज़ को बंद कर सकते हैं।",
      "क्या मैं स्नूज़ मोड को समय से पहले निष्क्रिय कर सकता हूँ?",
      "सेटिंग्स में जाएँ, स्नूज़ पर टैप करें और चुनें कि आप कितने समय के लिए दूर रहना चाहते हैं। जब भी आप तैयार महसूस करें, वापस आएँ।",
      "मैं अपनी प्रोफ़ाइल पर स्नूज़ मोड का उपयोग कैसे करूँ?",
      "नहीं—स्नूज़ मोड में रहते हुए, सभी स्वाइप-और-चैट गतिविधि रोक दी जाती है। जब आप नए लोगों से मिलने जाएंगे, तो आपको एक मैसेज दिखाई देगा जिसमें बताया जाएगा कि स्नूज़ मोड कितने समय तक चलेगा, साथ ही इसे निष्क्रिय करने का विकल्प भी दिया जाएगा।",
      "क्या मैं स्नूज़ मोड में भी प्रोफाइल देख सकता हूं और चैट कर सकता हूँ?",
      "जिन लोगों को आपने पहले ही मैसेज भेजा है, उन्हें आपका 'दूर' स्टेटस दिखाई देगा (अगर आप इसे सेट करना चाहते हैं)। अन्यथा, उन्हें आपके पिछले मैसेज अपने इनबॉक्स में सामान्य रूप से दिखाई देंगे।",
      "मेरे स्नूज़ मोड में होने पर वर्तमान मैच क्या देखेंगे?",
      "आपके पास अपनी Bumble गतिविधि पर पूर्ण नियंत्रण है, और आप जब चाहें प्लेटफ़ॉर्म से दूर जा सकते हैं।",
      "आप अपने स्टेटस अपडेट का उपयोग करके मौजूदा कनेक्शन को अपडेट रख सकते हैं, ताकि ऐसा न लगे कि आप <a href={{ghosted_article_url}}>भाग गए</a> हैं। साथ ही, यह सब स्वचालित है - इसलिए आपको कोई मैसेज भेजने की आवश्यकता नहीं है।",
      "अपने संपर्कों या चैट को खोए बिना सक्रिय रूप से डेटिंग से ब्रेक लें।",
      "अपनी शर्तों पर डेट करें (या डिस्कनेक्ट करें)",
      "अपने कनेक्शन को अपडेट रखें",
      "अपनी गतिविधि रोकें, लेकिन अपने कनेक्शन नहीं",
      "हमें स्नूज़ मोड क्यों पसंद है",
      "Bumble ऐप खोलें, अपने प्रोफ़ाइल टैब पर जाएँ और ऊपरी दाएँ कोने में सेटिंग कोग पर टैप करें। अपनी सेटिंग में, स्नूज़ पर टैप करें और चुनें कि आप कितने समय के लिए दूर रहेंगे। आप अपनी प्रोफ़ाइल को 24 घंटे, 72 घंटे, एक हफ़्ते या अनिश्चित काल के लिए छिपा सकते हैं।{{__EOL__}}{{__EOL__}}याद रखें, जब आप स्नूज़ मोड में होंगे, तो वो मैच समाप्त हो जाएँगे जिनसे आपकी चैट नहीं चल रही है। अगर आप कोई स्टेटस सेट करने का फ़ैसला करते हैं, तो आप जिन लोगों से चैट कर रहे हैं, वे देख पाएँगे कि आप दूर हैं।",
      "Bumble पर स्नूज़ मोड कैसे काम करता है",
      "जब जीवन व्यस्त हो जाए, तो स्नूज़ मोड आपकी मदद के लिए मौजूद है। अपना Bumble अकाउंट को विराम दें और अपनी शर्तों पर डेट करें।",
      "Bumble पर स्नूज़ मोड",
      "जब आप डेटिंग से ब्रेक लेना चाहते हों, स्नूज़ मोड आपके अकाउंट को विराम देने का एक आसान तरीका है। आप अभी भी अपने मौजूदा कनेक्शन के साथ चैट कर सकते हैं, यह सिर्फ़ आपकी प्रोफ़ाइल को दूसरे लोगों से तब तक छिपाता है जब तक आप फिर से शुरू करने के लिए तैयार नहीं हो जाते। स्नूज़ मोड को सक्रिय करके आप अपनी प्रोफ़ाइल जानकारी नहीं खोएँगे या मौजूदा कनेक्शन नहीं हटाएँगे।",
      "अपने Bumble प्रोफ़ाइल को स्नूज़ करें",
      "जब आप स्नूज़ मोड में होते हैं, तो आप मौजूदा कनेक्शन को स्टेटस अपडेट के ज़रिए यह बताना चुन सकते हैं कि आप आराम कर रहे हैं। 'मैं यात्रा कर रहा हूँ', 'मैं काम पर ध्यान केंद्रित कर रहा हूँ', 'मैं डिजिटल डिटॉक्स पर हूँ' या 'मैं खुद को प्राथमिकता दे रहा हूँ' में से चुनें। आपकी जो भी भावना हो, हम आपके साथ हैं।",
      "एक 'दूर' स्टेटस जोड़ें",
      "स्नूज़ मोड सक्रिय करने से आपके Bumble (या {{page_partner_name_bff}}) अकाउंट पर विराम लग जाता है। जब तक आप उन्हें नहीं बताते, तब तक आपके मैच को पता नहीं चलेगा कि आप स्नूज़ मोड पर हैं। अगर आप अपने स्नूज़ मोड से शुरू में चुनी गई समय-सीमा से पहले इसे बंद करने का फ़ैसला करते हैं, तो बस सेटिंग्स पर वापस जाएँ और “स्नूज़ मोड निष्क्रिय करें” पर टैप करें। यह इतना आसान है।",
      "अपनी चैट रोकें",
      "Bumble पर SuperSwipe को आज़माएं",
      "जितने चाहें उतने! {{service_level_lexeme_name}} यूजर्स को हर हफ़्ते {{num}} [[superswipe:num]] मिलते हैं, लेकिन आप किसी भी समय अपना बैलेंस टॉप अप कर सकते हैं। मुफ़्त सदस्य SuperSwipes के पैक खरीद सकते हैं।",
      "मैं Bumble पर कितने SuperSwipes भेज सकता हूँ?",
      "जब कोई व्यक्ति आपकी प्रोफ़ाइल पर SuperSwipe का उपयोग करेगा, तो आपको तुरंत इसकी सूचना मिल जाएगी। आपको उस व्यक्ति की प्रोफ़ाइल पर उसके नाम के ऊपर एक लेबल भी दिखाई देगा, जिससे आपको पता चलेगा कि वह आपको पसंद करता है।",
      "मुझे कैसे पता चलेगा कि मुझे किसी से SuperSwipe मिला है?",
      "क्या आप किसी के बारे में गंभीर हैं? चुप्पी तोड़ने का एक शानदार तरीका है। बस उन्हें एक SuperSwipe भेजें ताकि उन्हें पता चले कि आपको उनमें दिलचस्पी है और जल्दी से अच्छी बातचीत शुरू करें।",
      "Bumble पर SuperSwipe",
      "भीड़ से अलग दिखना हमेशा आसान नहीं होता, लेकिन SuperSwipe आपको एक बेहतरीन पहली छाप छोड़ने में मदद कर सकता है।{{__EOL__}}{{__EOL__}}जब आप SuperSwipe का इस्तेमाल करते हैं, तो आपके द्वारा पसंद किए गए व्यक्ति को एक सूचना भेजी जाएगी। फिर आप अपनी प्रोफ़ाइल पर एक लेबल के साथ उनके सामने आ जाएँगे। अगर वो भी आपको पसंद करते हैं, तो चैटिंग शुरू करने का समय आ गया है।",
      "SuperSwipe क्या है?",
      "बोल्ड बनें और भीड़ से अलग दिखें",
      "और चैट्स शुरू करें",
      "अधिक कनेक्शन बनाएं",
      "SuperSwipe यह करने में आपकी मदद कर सकते हैं…",
      "अगर आपके पास <a href={{bumble_boost_url}}>Bumble {{service_level_lexeme_name}} या Bumble {{service_level_lexeme_name_one}}</a> है, तो आपको हर हफ़्ते {{num}} मुफ़्त [[superswipe:num]] मिलते हैं। साथ ही, सभी मेंबर प्रोफ़ाइल टैब से {{num_two}} [[superswipe:num_two]] तक के पैक खरीद सकते हैं। अगर आपके पास {{service_level_lexeme_name_three}} है, तो आपको हर हफ़्ते {{num_three}} [[superswipe:num_three]] मिलेंगे।{{__EOL__}}{{__EOL__}}SuperSwipe का इस्तेमाल करना आसान है—जब आपको कोई ऐसा व्यक्ति दिखे जो आपको पसंद हो, तो बस उनकी प्रोफ़ाइल के नीचे पीले रंग के स्टार आइकन पर टैप करें।",
      "SuperSwipe का उपयोग कैसे करें",
      "Bumble पर ट्रैवल के साथ कहीं भी डेट करें",
      "<a href={{bumble_premium_url}}>{{service_level_lexeme_name}} मेंबर्स</a> ट्रैवल का उपयोग कर सकते हैं। इसे चालू करें और आपकी कतार आपको आपके चुने हुए शहर में नए चेहरे दिखाएगी।",
      "मैं ट्रैवल का उपयोग कैसे करूं?",
      "बहुत हद तक - हमारे पास कुछ सुरक्षा प्रतिबंध हैं जो समय के साथ बदल सकते हैं, लेकिन ट्रैवल अधिकांश गंतव्यों के लिए उपलब्ध है।",
      "क्या मैं ट्रैवल का उपयोग कहीं भी कर सकता हूँ?",
      "ट्रैवल आपके चुने हुए शहर के केंद्र के रूप में आपका स्थान दिखाएगा, ताकि क्षेत्र में नए कनेक्शन आपको ढूंढ सकें। उन्हें आपकी प्रोफ़ाइल पर एक नोट दिखाई देगा कि आप ट्रैवल में हैं, इसलिए उन्हें पता चल जाएगा कि आप यात्रा कर रहे हैं, या यात्रा करने की योजना बना रहे हैं।",
      "छुट्टियों के लिए अपना बैग पैक कर रहे हैं या काम के लिए किसी नए शहर में जा रहे हैं? डेटिंग को अपने साथ ले जाने के लिए Bumble के ट्रैवल को चालू करें।",
      "Bumble पर ट्रैवल",
      "ट्रैवल आपके दूर रहने के दौरान कनेक्शन बनाने का आपका सबसे बढ़िया साधन है। दुनिया में कहीं भी अपनी लोकेशन सेट करें, और आपकी प्रोफ़ाइल आपके द्वारा चुने गए शहर में दिखाई देगी। इसका मतलब है कि आप जहाँ भी अपने रोमांच के साथ डेटिंग कर सकते हैं।",
      "ट्रैवल क्या है?",
      "स्थानीय लोगों से बेहतर किसी जगह के बारे में कोई नहीं जानता। ट्रैवल आपको उन लोगों से जुड़ने में मदद कर सकता है जो आपकी यात्रा को और भी खास बना देंगे।",
      "अपनी यात्रा से सात दिन पहले ही शहर में अपनी लोकेशन सेट करें, ताकि आप पहले से ही डेट की योजना बना सकें और अपने लिए उपयुक्त व्यक्ति से मिल सकें।",
      "समुद्र के किनारे घूमने से आगे की सोचें—आप छुट्टियों में घर जा सकते हैं, काम के सिलसिले में यात्रा कर सकते हैं या किसी नए शहर में घूम सकते हैं। आप जहाँ भी जाएँ, रोमांस पाएँ।",
      "सर्वोत्तम स्थानीय डेटिंग स्पॉट खोजें",
      "एडवेंचर में भाग लेना",
      "स्थायी कनेक्शन बनाएँ",
      "ट्रैवल को प्यार करने का कारण",
      "ट्रैवल <a href={{bumble_premium_url}}>{{service_level_lexeme_name}} और {{service_level_lexeme_name_two}}</a> के मेंबर्स के लिए Bumble पर उपलब्ध है। अपनी प्रोफ़ाइल के शीर्ष दाईं ओर सेटिंग कोग पर टैप करें और तब तक स्क्रॉल करें जब तक आपको ट्रैवल दिखाई न दे। उस क्षेत्र में लोगों से मिलना शुरू करने के लिए अपना नया स्थान चुनें। आपकी प्रोफ़ाइल संभावित डेट को बताएगी कि आप ट्रैवल में हैं।",
      "ट्रैवल कैसे काम करता है?",
      "इसे अभी आज़माएं",
      "यहां, दयालु होना सेक्सी है, आप परफेक्ट हैं, और महिलाएं हमेशा पहले आती हैं। हमेशा।",
      "'पहला कदम बढ़ाएं' का घर",
      "अच्छे संबंध एक सकारात्मक, उपयोगी ज़िंदगी के लिए महत्वपूर्ण हैं। Bumble को आपको कनेक्शन बनाने पर सशक्त महसूस करने में मदद करने के लिए बनाया गया है, चाहे आप डेटिंग कर रहे हों, दोस्तों को ढूँढ रहे हों, या अपना प्रोफेशनल नेटवर्क बढ़ा रहे हों।",
      "Bumble मायने क्यों रखता है",
      "हम किसी भी रिश्ते के सभी चरणों के दौरान सच्चाई, नेकी, समानता, आत्मविश्वास और सम्मान का समर्थन करते हैं। हम सिर्फ स्वागत नहीं करते, हम हर ओरीएन्टेशन का जश्न मनाते हैं—चाहे आप यहां प्यार ढूंढने आए हों या बस मनोरंजन ढूंढने आए हों।",
      "Bumble किसे महत्व देता है",
      "Bumble पर, महिलाएं पहले कदम बढ़ाकर या मैचों द्वारा जवाब देने के लिए Opening Move सेट करके माहौल तैयार करती हैं। हमारा मकसद पुराने जमाने की रूढ़िवादी सोच को बदलना और शुरू से ही समानता को प्रोत्साहित करना है।",
      "Bumble कैसे काम करता है",
      "हमारे बारे में",
      "अभी डाउनलोड करें",
      "यह ऐप पर बेहतर है।",
      "ऑनलाइन डेटिंग को सच में मज़ेदार बनाने के लिए डिज़ाइन किए गए फीचर",
      "फरवरी 12, 2024",
      "अपने रिश्ते में इमोशनल लगाव कैसे बढ़ाएं",
      "जनवरी 25, 2024",
      "जब आपने पहले कभी डेटिंग ऐप का उपयोग नहीं किया है तो Bumble का उपयोग कैसे करें",
      "फरवरी 5, 2024",
      "Deception Detector™",
      "सभी डेटिंग समाचार जो छापने योग्य हैं",
      "<b>स्नूज़ मोड</b> के साथ डेटिंग को होल्ड पर रखें। जब आप फिर से डेट करने के लिए तैयार हों, आपको पता ही है कि हम कहाँ हैं।",
      "एक ब्रेक लें",
      "अपना घर छोड़े बिना असल ज़िंदगी में करीब पहुंचने के लिए <b>वीडियो कॉल</b> और <b>ऑडियो चैट</b> का उपयोग करें।",
      "बात करें",
      "और देखें",
      "चैट शुरू करने के लिए अपने मैच को आमंत्रित करने के लिए <b>Opening Moves</b> चुनें, ताकि आपको ऐसा न करना पड़े।",
      "काम कम, डेट ज्यादा",
      "<b>ट्रैवल</b> के साथ दुनिया में कहीं भी ड्यूटी-फ्री स्नैक और मैच ढूंढें।",
      "हमें अपने साथ ले जाएं",
      "प्रोफ़ाइल वाइब जांच में पास हुई? <b>SuperSwipe</b> से उन्हें बताएं।",
      "उनका ध्यान खींचे",
      "उनकी कुछ <b>तारीफ</b> करें ताकि आप भीड़ से अलग दिखें।",
      "उन्हें शर्माने के लिए मजबूर करें",
      "अपने बॉस, रिश्तेदारों या पूर्व साथियों से अपनी प्रोफ़ाइल छिपाने के लिए <b>गुप्त मोड</b> का उपयोग करें।",
      "गुप्त हो जाएं",
      "जिस तरह से आप चाहें, उसी तरह डेट करें",
      "कुछ महीनों बाद, उसकी मुलाकात वहां उसकी ब्राइडमेडस से भी हुई",
      "हन्ना अपने वर्तमान पति से Bumble पर मिलीं।",
      "एक साथ अपना छोटा सा घर बनाने से पहले करीन और यू-लिआंग की मुलाकात Bumble पर हुई थी, जहां कैरेन की ट्रेवल की फ़ोटोज़ ने यू-लियांग को आकर्षित किया था।",
      "करीन और यू-लिआंग",
      "ब्रायन और केसी विदेश में एक साथ तैनात थे—लेकिन उनकी मुलाकात Bumble पर हुई",
      "ब्रायन और केसी",
      "यदि यह उनके लिए काम करता है, तो यह आपके लिए भी काम कर सकता है",
      "अगला कदम बढ़ाएं",
      "देखें कि नया क्या है",
      "आप बेहतर के हकदार हैं, इसलिए हमने आपके लिए अधिक डेट करने और तनाव कम करने के बेहतरीन तरीके डिज़ाइन किए हैं।",
      "अपने बार को वापस वहीं लाएँ जहाँ इसे होना चाहिए",
      "Bumble के बारे में",
      "हम एकमात्र ऐप हैं जो महिलाओं के अनुभवों को पहले स्थान पर रखकर डेटिंग को बेहतर बनाते हैं। क्योंकि जब चीजें महिलाओं के लिए बेहतर होती हैं, तो वे सभी के लिए बेहतर होती हैं।",
      "Make the first move™",
      "किसी ऐसे व्यक्ति को ढूंढें जिसे आप वास्तव में डेट करना चाहते हैं, फिर आगे बढ़ें और पहला कदम उठाएं। असल कनेक्शन बनाएं, वो करें जो आप दोनों को पसंद है और सबसे महत्वपूर्ण बात यह है कि मजे लें।",
      "Bumble Date पर किसी से मिलें",
      "ऐसे दोस्तों को ढूंढें जो कार्य क्षेत्र में आपकी मदद कर सकें। अपनी अगली नौकरी, गुरू या यहां तक कि एक नया करियर ढूंढने के लिए अन्य बिज़नस प्रोफेशनल्स से कनेक्ट करें।",
      "Bumble Bizz के साथ कैरियर को आगे बढ़ाएं",
      "अपने जैसे या अपने से विपरीत किसी व्यक्ति से मिलें। नए दोस्त बनाएं और साथ मिलकर करने के लिए नई चीजें खोजें - चाहे आप घर पर हों या बाहर।",
      "Bumble For Friends पर नये दोस्त बनाएं",
      "हम केवल डेटिंग के लिए नहीं हैं",
      "Bumble एक डेटिंग ऐप है जहां महिलाएं पहले कदम बढ़ाती हैं। यह वह ऐप है जिसने लोगों के डेट करने, सार्थक रिश्ते बनाने और नेटवर्क बनाने के तरीके को बदल दिया है। अब डाउनलोड करें।",
      "{{social_network}} पर Bumble",
      "और जानिये",
      "App Store या Google Play से Bumble ऐप डाउनलोड करें और उसी अकाउंट से साइन इन करें जिसका इस्तेमाल आपने Bumble वेब पर किया था।{{__EOL__}}{{__EOL__}}शुरू करने के लिए अपने फ़ोन या टैबलेट से नीचे दिए गए QR कोड को स्कैन करें।{{__EOL__}}{{__EOL__}}आपके मैच और बातचीत ऐप पर आपका इंतज़ार कर रहे हैं। 💛",
      "ऐप प्राप्त करें",
      "ताकि हम आपको सबसे अच्छा अनुभव और सुरक्षा सुविधाएँ देते रहें, Bumble अब सिर्फ़ ऐप पर उपलब्ध है।",
      "Bumble अब केवल ऐप है।",
      "कभी भी कोई कनेक्शन न चूकें",
      "अपना नंबर शेयर किए बिना कॉल करें",
      "भरोसा करें कि आपके मैच असली हैं",
      "असल समय में सूचनाएं प्राप्त करें ताकि आप कभी भी मैसेज से ना चूकें।",
      "मैच से असल जीवन में सुरक्षित रूप से मिलने के लिए हमारे इन-ऐप वॉइस और वीडियो कॉल का इस्तेमाल करें।",
      "आसान ऐप में फ़ोटो और ID वेरिफ़िकेशन का इस्तेमाल करके वेरीफाइड मेंबर्स के साथ विश्वास से चैट करें।",
      "Bumble ऐप पर स्विच क्यों करें?",
      "Gender Pay Gap",
      "Modern Slavery Statement",
      "Terms and Conditions",
      "About",
      "Life",
      "Premium+",
      "हमें खेद है, पर आप जिस पेज को खोज रहे हैं हम उसे खोज नहीं सके हैं।",
      "हमसे संपर्क करें",
      "अरे रे! कुछ गड़बड़ हो गई है",
      "(opens in new window)",
      "अक्सर पूछे जाने वाले सवाल",
      "Cookie Policy",
      "Premium",
      "Bumble - The Blog",
      "नौकरी",
      "चैट",
      "शहर",
      "कुकी मैनेज करें",
      "Copyright © 2006 – present. Bumble. सभी अधिकार सुरक्षित हैं.",
      "डेटिंग कॉन्फ़िडेंस रिपोर्ट",
      "Apple और Apple का लोगो Apple Inc के ट्रेडमार्क हैं.{{__EOL__}}Google Play, Google LLC का ट्रेडमार्क है.",
      "डाउनलोड करें",
      "Facebook",
      "हमें फ़ॉलो करें",
      "सहायता केंद्र",
      "Instagram",
      "भाषा",
      "LinkedIn",
      "Bumble, Bumble Inc का हिस्सा है.",
      "निजता नीति",
      "सुरक्षा केंद्र",
      "साइटमैप",
      "मॉडर्न स्लेवरी ऐक्ट स्टेटमेंट",
      "नियम और शर्तें",
      "Twitter"
],

    // These are the common words found in the lexemes of the app
    common: {
      "Compliments": {
            "plural": [
                  "तारीफें",
                  "तारीफें"
            ],
            "singular": [
                  "तारीफ",
                  "तारीफ"
            ]
      },
      "day": {
            "plural": [
                  "दिनों",
                  "दिनों"
            ],
            "singular": [
                  "दिन",
                  "दिन"
            ]
      },
      "hour": {
            "plural": [
                  "घंटे",
                  "घंटे"
            ],
            "singular": [
                  "घंटे",
                  "घंटे"
            ]
      },
      "minute": {
            "plural": [
                  "मिनट",
                  "मिनट"
            ],
            "singular": [
                  "मिनट",
                  "मिनट"
            ]
      },
      "month": {
            "plural": [
                  "महीने",
                  "महीनों"
            ],
            "singular": [
                  "महीना",
                  "महीना"
            ]
      },
      "second": {
            "plural": [
                  "सेकंड",
                  "सेकंड"
            ],
            "singular": [
                  "सेकंड",
                  "सेकंड"
            ]
      },
      "superswipe": {
            "plural": [
                  "SuperSwipes",
                  "SuperSwipes"
            ],
            "singular": [
                  "SuperSwipe",
                  "SuperSwipe"
            ]
      },
      "year": {
            "plural": [
                  "साल",
                  "सालों"
            ],
            "singular": [
                  "साल",
                  "साल"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
